/* ================================================== */
/* PLYR → init
/* ================================================== */

$(document).ready(function(){
	plyr.setup();
});